import axios from "@/api/axiosInstance";
import type { GetSubscriptionOfferingResponse } from "./types";

export const getSubscriptionOffering = async (
  slug: string,
): Promise<GetSubscriptionOfferingResponse> => {
  const response = await axios.get<GetSubscriptionOfferingResponse>(
    `/api/private/subscriptions/details/${encodeURIComponent(slug)}`,
  );
  return response.data;
};
